import { UserButton } from '@clerk/react';
import { Settings } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';

import { cn } from '@/lib/utils';
import { getNavItems } from '@/lib/navigation';

export default function AppShell() {
  return (
    <div className="min-h-screen bg-muted/30">
      <div className="flex min-h-screen">
        <aside className="hidden w-60 border-r bg-background/80 p-4 lg:block">
          <div className="mb-6 flex items-center gap-2 text-lg font-semibold">
            <Settings className="h-5 w-5" />
            Writer Admin
          </div>
          <nav className="space-y-1">
            {getNavItems().map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }: { isActive: boolean }) =>
                    cn(
                      'flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-muted',
                      isActive
                        ? 'bg-muted text-foreground'
                        : 'text-muted-foreground',
                    )
                  }
                  end={item.to === '/'}
                >
                  <Icon className="h-4 w-4" />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
        </aside>
        <main className="flex-1">
          <header className="flex items-center justify-between border-b bg-background/80 px-2 py-2 sm:px-4 sm:py-3">
            <div className="text-lg font-semibold">Admin Console</div>
            <UserButton
              appearance={{ elements: { userButtonAvatarBox: 'h-8 w-8' } }}
            />
          </header>
          <div className="px-2 py-3 sm:px-4 sm:py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
